import { isTransientNetworkError, isRateLimitedError, rateLimitedMessage } from "@/utils/networkErrors";
import { isSessionDeadError } from "@/utils/sessionExpiry";
import { configureRollbarPerson } from "@/utils/rollbarPerson";
import { isMoneyDeclined } from "@/utils/moneyConfirmGuard";

export function reportModuleFailure(vm, err, { text, parse, silent = false, errorTitle } = {}) {
  const parsed = parse(err);
  if (parsed && parsed.i18nKey) {
    const human = vm.$t(parsed.i18nKey);
    if (!silent && vm.$notify) vm.$notify(text, human, "warning", 6000);
    return human;
  }
  if (vm.isLoading === true) vm.isLoading = false;
  if (isSessionDeadError(err) || isMoneyDeclined(err)) return text;
  if (isRateLimitedError(err)) {
    const human = rateLimitedMessage(vm, err);
    if (!silent && vm.$notify) vm.$notify(text, human, "warning", 6000);
    return human;
  }
  const status = err && err.response && err.response.status;
  if (status !== 422 && status !== 406 && vm.$reportError) {
    // Контекст события (пользователь, компания) — как у setErrorMixin.
    configureRollbarPerson(vm);
    vm.$reportError(text, err);
  }
  if (!silent && !isTransientNetworkError(err) && vm.$notify) vm.$notify(errorTitle ? errorTitle() : text, text, "error", 5000);
  return text;
}
